// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__30LHS","requiredAsterisk":"Info_requiredAsterisk__1iend"};